import { apiRequest } from "../remote/apiHelper";
import { ApiPaths } from "../remote/apiPaths";
import { UserModel } from "../models/UserModel";
import { showLog } from "../helper/utility";

export const login = async (
  payload: any
): Promise<{ admin: UserModel | null; response: boolean }> => {
  try {
    const response = await apiRequest(ApiPaths.LOGIN(), "POST", payload);
    if (response.success) {
      return {
        admin: response.data.record,
        response: true,
      };
    } else {
      showLog("Admin login failed:", response.message || "Unknown error");
      return {
        admin: null,
        response: false,
      };
    }
  } catch (error) {
    showLog("Error during admin login:", error);
    return {
      admin: null,
      response: false,
    };
  }
};

export const logout = async (): Promise<Boolean> => {
  try {
    const response = await apiRequest(ApiPaths.LOGOUT(), "POST");
    if (response.success) {
      return true;
    } else {
      showLog("Admin logout failed:", response.message || "Unknown error");
      return false;
    }
  } catch (error) {
    showLog("Error during user logout:", error);
    return false;
  }
};
